import { Neo } from "@singularsystems/neo-react";
import { DateSelectionComponent, NeoReport, Report } from "@singularsystems/neo-reporting";
import { AppService, DomainTypes } from "../../../Domain/DomainTypes";
import CustomInvestorInvestmentDetailCriteria from "./CustomInvestorInvestmentDetailCriteria";
import { ReportCategory } from "../ReportCategory";

@NeoReport("CustomInvestorInvestmentDetail", { category: ReportCategory.InvestorReports })
export default class CustomInvestorInvestmentDetail extends Report<CustomInvestorInvestmentDetailCriteria> {

    constructor(
        private dataCache = AppService.get(DomainTypes.Services.DataCache)
    ) {
        super(CustomInvestorInvestmentDetailCriteria);
    }

    public renderCriteria() {
        return <div>
            <DateSelectionComponent criteria={this.criteria} />
            <Neo.GridLayout md={2} lg={3}>
                <div>
                    <Neo.FormGroup bind={this.criteria.meta.entityId} select={{itemSource: this.dataCache.entities, allowNulls: true}} />
                </div>
            </Neo.GridLayout>
        </div>;
    }
}